export const handleChildValidation = (
	reqBody,
	childId,
	requireStandaloneResourceParentFields
) => {
	if (reqBody.dob === 'error') {
		return { isValid: false, message: 'Date of birth is required' };
	}
	if (childId && reqBody.firstname === '') {
		return { isValid: false, message: 'First name is required' };
	}

	if (childId && reqBody.lastname === '') {
		return { isValid: false, message: 'Last name is required' };
	}

	if (!childId && !reqBody.firstname) {
		return { isValid: false, message: 'First name is required' };
	}

	if (!childId && !reqBody.lastname) {
		return { isValid: false, message: 'Last name is required' };
	}

	if (requireStandaloneResourceParentFields) {
		if (childId && reqBody.swEmail === '') {
			return { isValid: false, message: 'Social Worker Email is required' };
		}

		if (!childId && !reqBody.swEmail) {
			return { isValid: false, message: 'Social Worker Email is required' };
		}

		if (childId && reqBody.agencyName === '') {
			return { isValid: false, message: 'Agency Name is required' };
		}

		if (!childId && !reqBody.agencyName) {
			return { isValid: false, message: 'Agency Name is required' };
		}
	}

	return { isValid: true };
};
